import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { NO_OP_FUNCTION } from "services/helpers";
import "./style.scss";

class InputRange extends PureComponent {
  /**
   * @returns {ReactComponent}
   */
  render() {
    const {
      id,
      name,
      className,
      value,
      min,
      max,
      step,
      onChange,
      disabled
    } = this.props;

    // Round to prevent JS floating point rounding issues.
    // Eg. 55.00000000001 -> 55
    const roundedVal = Math.round(value);

    return (
      <input
        id={id}
        name={name}
        type="range"
        min={min}
        max={max}
        step={step}
        data-value={roundedVal}
        value={roundedVal}
        disabled={disabled}

        // Use onInput instead of onChange
        // because of Chrome bug with initial event firing
        onInput={onChange}

        // Need to keep onChange and pass this void function
        // to disable React warnings
        onChange={NO_OP_FUNCTION}

        className={classNames(
          "InputRange",
          { [className]: className }
        )}
        style={{ backgroundSize: `${((roundedVal - min) / (max - min)) * 100}% 100%` }}
      />
    );
  }
}

InputRange.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

InputRange.defaultProps = {
  id: "",
  name: "",
  className: "",
  min: 0,
  max: 100,
  step: 10,
  disabled: false
};

export default InputRange;
